import React from 'react'
import { Route } from 'react-router-dom'

import Home from './Home'
import Login from './../containers/Login'
import Register from './../containers/Register'
import ForgotPassword from './../containers/ForgotPassword'
import Terms from './Terms'

import { ConnectedRouter } from 'react-router-redux'
import { history } from './../App'

const Router = () => (
  <ConnectedRouter history={history}>
    <div>
      <Route exact path='/' component={Home}/>
      <Route path='/login' component={Login}/>
      <Route path='/register' component={Register}/>
      <Route path='/password/reset' component={ForgotPassword}/>

      <Route path='/terms' component={Terms}/>
      {/*
      <Route path='/faq' component={FAQ}/>
      <Route path='/features' component={Featurese}/>
      */}
    </div>
  </ConnectedRouter>
)
export default Router



// WEBPACK FOOTER //
// ./src/components/Router.js